__turbopack_context__.v({
  "heart-wrapper": "HeartHunter-module__FWd8hq__heart-wrapper",
  "heartCarousel": "HeartHunter-module__FWd8hq__heartCarousel",
});
